<template>
  <div>
    <div v-if="activityStatus == 'new' || activityStatus == 'edit'">
      <base-header class="pb-6 bg-primary">
        <b-row class="align-items-center py-4">
          <b-col cols="12" class="d-flex align-items-center">
            <base-button type="danger" class="mr-3" @click="resetBrokerOrgForm">
              Back
            </base-button>
            <h6 class="h2 text-white d-inline-block mb-0">
              Broker Organisations
            </h6>
          </b-col>
        </b-row>
      </base-header>
      <div class="container-fluid mt--6">
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form
            class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)"
          >
            <b-card no-body class="mb-4">
              <b-card-header>
                <h3 class="mb-0">
                  {{
                    activityStatus == "add"
                      ? "Create new broker organisation"
                      : "Editing: " + model.orgName
                  }}
                </h3>
              </b-card-header>
              <b-card-body>
                <b-row>
                  <b-col md="6">
                    <base-input
                      name="Organisation Name"
                      label="Organisation Name"
                      v-model="model.orgName"
                      placeholder="Acme PTY Ltd"
                      rules="required"
                    />
                  </b-col>
                  <b-col md="6">
                    <base-input
                      name="ABN"
                      label="ABN"
                      v-model="model.orgABN"
                      rules="required"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <base-input
                      name="Insurance Issuer"
                      label="Insurance Issuer"
                      rules="required"
                    >
                      <el-select
                        v-model="model.insuranceBrokerId"
                        filterable
                        placeholder="Please select an Insurance Issuer"
                      >
                        <el-option
                          v-for="item in insuranceBrokerList"
                          :key="item.insurance_broker_id"
                          :label="item.insurance_broker_name"
                          :value="item.insurance_broker_id"
                        >
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>

                  <b-col md="6">
                    <base-input name="Introducer" label="Introducer">
                      <el-select
                        v-model="model.introducer"
                        filterable
                        clearable
                        placeholder="Have you been referred by another organization?"
                      >
                        <el-option
                          v-for="item in getBrokerOrgList"
                          :key="item.Broker_org_id"
                          :label="item.Broker_Org_Name"
                          :value="item.Broker_org_id"
                        >
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <h3>Access Permissions</h3>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <base-input name="InsuranceBroker" label="Insurance Broker">
                      <base-switch
                        style="margin-top:9px;"
                        on-text="Yes"
                        off-text="No"
                        v-model="model.isInsuranceBroker"
                      >
                      </base-switch>
                    </base-input>
                  </b-col>
                </b-row>

                <b-row v-if="!model.isInsuranceBroker">
                  <b-col md="6">
                    <base-input
                      name="Finance Network"
                      label="Finance Network"
                    >
                      <el-select
                        v-model="model.financeNetworkId"
                        filterable
                        clearable
                        placeholder="Optional — group finance orgs for shared quote visibility"
                      >
                        <el-option
                          v-for="item in financeNetworkList"
                          :key="item.finance_network_id"
                          :label="item.name"
                          :value="item.finance_network_id"
                        >
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <base-input name="Notes" label="Notes">
                      <b-form-textarea
                        id="broker-org-notes"
                        v-model="model.notes"
                        rows="4"
                        max-rows="10"
                        placeholder="Internal notes about this broker organisation"
                      ></b-form-textarea>
                    </base-input>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <h3>Features</h3>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="4">
                    <b-row>
                      <b-col>
                        <base-input
                          label="Can see VIBS products (Default)"
                        >
                          <button-radio-group
                            id="can-see-vibs"
                            :value="model.defaultShowPe"
                            v-model="model.defaultShowPe"
                            :options="twoOptions"
                            name="can-see-vibs"
                            buttons
                            style="margin-top: 0px;"
                          ></button-radio-group>
                        </base-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <base-input label="Can see Light Commercial  (Default)">
                          <button-radio-group
                            id="can-see-light-commercial"
                            :value="model.defaultShowLc"
                            v-model="model.defaultShowLc"
                            :options="twoOptions"
                            name="can-see-light-commercial"
                            buttons
                            style="margin-top: 0px;"
                          ></button-radio-group>
                        </base-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <base-input label="Can see Fleet Management (Default)">
                          <button-radio-group
                            id="can-see-fleet-management"
                            :value="model.can_see_fleet_management"
                            v-model="model.can_see_fleet_management"
                            :options="twoOptions"
                            name="can-see-fleet-management"
                            buttons
                            style="margin-top: 0px;"
                          ></button-radio-group>
                        </base-input>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col md="4">
                    <b-row>
                      <b-col>
                        <base-input label="Can see Rideshare (Default)">
                          <button-radio-group
                            id="can-see-ride-share"
                            :value="model.defaultShowRs"
                            v-model="model.defaultShowRs"
                            :options="twoOptions"
                            name="can-see-ride-share"
                            buttons
                            style="margin-top: 0px;"
                          ></button-radio-group>
                        </base-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <base-input label="Can Adjust Policy">
                          <button-radio-group
                            id="can-adjust-policy"
                            :value="model.can_adjust_policy"
                            v-model="model.can_adjust_policy"
                            :options="twoOptions"
                            name="can-adjust-policy"
                            buttons
                            style="margin-top: 0px;"
                          ></button-radio-group>
                        </base-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <base-input label="Can see Fleet">
                          <button-radio-group
                            id="can-see-fleet"
                            :value="model.can_see_fleet"
                            v-model="model.can_see_fleet"
                            :options="threeOptions"
                            name="can-see-fleet"
                            buttons
                            style="margin-top: 0px;"
                          ></button-radio-group>
                        </base-input>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col md="4">
                    <b-row>
                      <b-col>
                        <base-input label="Can see Claims">
                          <button-radio-group
                            id="can-see-claims"
                            :value="model.can_see_claims"
                            v-model="model.can_see_claims"
                            :options="threeOptions"
                            name="can-see-claims"
                            buttons
                            style="margin-top: 0px;"
                          ></button-radio-group>
                        </base-input>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col>
                        <base-input label="Can Cancel Policy">
                          <button-radio-group
                            id="can-cancel-policy"
                            :value="model.can_cancel_policy"
                            v-model="model.can_cancel_policy"
                            :options="threeOptions"
                            name="can-cancel-policy"
                            buttons
                            style="margin-top: 0px;"
                          ></button-radio-group>
                        </base-input>
                      </b-col>
                    </b-row>

                    <!-- <b-row>
                      <b-col>
                        <base-input label="Can Receive Invoice">
                          <button-radio-group
                            id="can-receive-invoice"
                            :value="model.can_receive_invoice"
                            v-model="model.can_receive_invoice"
                            :options="threeOptions"
                            name="can-receive-invoice"
                            buttons
                            style="margin-top: 0px;"
                          ></button-radio-group>
                        </base-input>
                      </b-col>
                    </b-row> -->
                  </b-col>
                </b-row>

                <b-row class="d-flex justify-content-center">
                  <base-button
                    @click="resetBrokerOrgForm"
                    type="danger"
                    class="mr-4"
                    >Cancel</base-button
                  >
                  <base-button @click="saveChanges" type="danger"
                    >Save</base-button
                  >
                </b-row>
              </b-card-body>
            </b-card>
          </form>
        </validation-observer>
      </div>
    </div>
    <div class="container-fluid" v-if="!(activityStatus == 'new' || activityStatus == 'edit')">
      <b-alert
        v-if="importSummary"
        show
        :variant="importSummary.failed ? 'warning' : 'success'"
        dismissible
        @dismissed="importSummary = null"
        class="mt-3"
      >
        <div>
          CSV import:
          <strong>{{ importSummary.created }}</strong> created,
          <strong>{{ importSummary.skipped }}</strong> skipped,
          <strong>{{ importSummary.failed }}</strong> failed.
        </div>
        <ul
          v-if="importSummary.errors && importSummary.errors.length"
          class="mb-0 mt-2"
          style="max-height: 180px; overflow: auto;"
        >
          <li v-for="(err, idx) in importSummary.errors" :key="idx">
            Line {{ err.line }} — {{ err.name }}: {{ err.reason }}
          </li>
        </ul>
      </b-alert>
      <card body-classes="px-0 pb-1" footer-classes="pb-2">
        <div>
          <b-col
            cols="12"
            class="d-flex justify-content-center justify-content-sm-between flex-wrap change-color"
          >
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <div>
              <base-input
                v-model="searchQuery"
                prepend-icon="fas fa-search"
                placeholder="Search..."
                v-on:input="resetPagination()"
              >
              </base-input>
            </div>
            <div class="d-flex align-items-center">
              <input
                ref="csvFileInput"
                type="file"
                accept=".csv,text/csv"
                class="d-none"
                @change="onCsvFileSelected"
              />
              <base-button
                class="mr-2"
                type="secondary"
                :disabled="importingCsv || loading"
                @click="exportBrokerOrgsCsv"
              >
                Export to CSV
              </base-button>
              <base-button
                class="mr-2"
                type="secondary"
                :disabled="importingCsv"
                @click="triggerCsvImport"
              >
                {{ importingCsv ? "Importing…" : "Import CSV" }}
              </base-button>
              <base-button @click="addBroker()" type="danger"
                >Add new Broker Org</base-button
              >
            </div>
          </b-col>
          <el-table
            :data="queriedData"
            row-key="id"
            header-row-class-name="thead-light"
            @sort-change="sortChange"
            @selection-change="selectionChange"
            v-loading="loading"
          >
            <el-table-column min-width="100px" align="left" label="Edit">
              <div slot-scope="{ row }">
                <base-button
                  @click.native="populateForm(row)"
                  class="edit"
                  type="danger"
                  size="sm"
                  icon
                  v-b-tooltip.hover
                  title="View / Edit"
                >
                  <i class="text-white ni ni-ruler-pencil"></i>
                </base-button>
              </div>
            </el-table-column>

            <el-table-column
              label="Name"
              prop="Broker_Org_Name"
              min-width="190px"
              sortable
            >
            </el-table-column>

            <el-table-column
              label="Insurance Issuer"
              prop="insurance_issuer"
              min-width="190px"
              sortable
            >
            </el-table-column>

            <el-table-column
              label="Finance Network"
              min-width="180px"
              :formatter="formatFinanceNetwork"
            >
            </el-table-column>
            <template #empty>
              <p>{{ loading ? "" : "No broker org found" }}</p>
            </template>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

              <span v-if="selectedRows.length">
                &nbsp; &nbsp; {{ selectedRows.length }} rows selected
              </span>
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            :value="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @change="paginationChanged($event)"
          >
          </base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { GlobalStore } from "../../globalStore";
import { toasts } from "../../helpers/toasts";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../../components/PaginatedTables/clientPaginationMixin";
import ButtonRadioGroup from "../../components/ButtonRadioGroup.vue";
import { appFunctions } from "../../helpers/appFunctions";

export default {
  data() {
    return {
      loading: false,
      importingCsv: false,
      activityStatus: "add",
      currentBrokerOrgId: "",
      tableData: [],
      selectedRows: [],
      insuranceBrokerList: [],
      financeNetworkList: [],
      importSummary: null,
      model: {
        orgName: "",
        orgABN: "",
        insuranceIssuer: "",
        insuranceIssuerEmail: "",
        insuranceIssuerAccountsPayable: "",
        insuranceBrokerId: "",
        introducer: "",
        isInsuranceBroker: false,
        financeNetworkId: null,
        notes: "",
        defaultShowLc: false,
        defaultShowPe: false,
        defaultShowRs: false,
        can_see_fleet_management: false,
        can_adjust_policy: false
      },
      threeOptions: [
        {
          label: 'Inherit',
          value: null
        },
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ],
      twoOptions: [
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ]
    };
  },
  name: "BrokerOrg",
  methods: {
    // TABLE METHODS
    addBroker() {
      this.resetBrokerOrgForm();
      this.activityStatus = "new";
    },
    triggerCsvImport() {
      if (this.importingCsv) {
        return;
      }
      this.$refs.csvFileInput && this.$refs.csvFileInput.click();
    },
    csvEscape(value) {
      const str = value == null ? "" : String(value);
      if (/[",\r\n]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    },
    resolveIntroducerName(introducerId) {
      if (!introducerId) {
        return "";
      }
      const found = (this.tableData || []).find(
        (item) => item.Broker_org_id === introducerId
      );
      return found ? found.Broker_Org_Name : "";
    },
    resolveFinanceNetworkName(org) {
      if (!org || !org.finance_network_id) {
        return "";
      }
      const found = this.financeNetworkList.find(
        (item) => item.finance_network_id === org.finance_network_id
      );
      return found ? found.name : "";
    },
    exportBrokerOrgsCsv() {
      const header = [
        "Broker Name",
        "ABN",
        "Insurance Issuer",
        "Finance Network",
        "Introducer",
        "Notes",
      ];
      const rows = (this.tableData || []).map((org) => [
        this.csvEscape(org.Broker_Org_Name || ""),
        this.csvEscape(org.Broker_org_abn || ""),
        this.csvEscape(org.insurance_issuer || ""),
        this.csvEscape(this.resolveFinanceNetworkName(org)),
        this.csvEscape(this.resolveIntroducerName(org.introducer)),
        this.csvEscape(org.notes || ""),
      ]);

      const csvContent = [header.join(",")]
        .concat(rows.map((cols) => cols.join(",")))
        .join("\r\n");

      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const stamp = new Date().toISOString().slice(0, 10);
      link.href = url;
      link.download = `broker-orgs-export-${stamp}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      toasts.success(`Exported ${rows.length} broker organisations.`);
    },
    async onCsvFileSelected(event) {
      const file = event && event.target && event.target.files && event.target.files[0];
      if (this.$refs.csvFileInput) {
        this.$refs.csvFileInput.value = "";
      }
      if (!file) {
        return;
      }

      this.importingCsv = true;
      this.importSummary = null;
      try {
        const [issuerResp, networkResp] = await Promise.all([
          appFunctions.crud_insuranceBroker("list"),
          appFunctions.crud_financeNetwork("list", {}),
        ]);
        this.insuranceBrokerList = issuerResp.data || [];
        this.financeNetworkList = networkResp.data || [];

        const text = await this.readFileAsText(file);
        const rows = this.parseBrokerOrgCsv(text);
        if (!rows.length) {
          toasts.error("No data rows found in the CSV.");
          return;
        }

        const result = await this.importBrokerOrgsFromRows(rows);
        this.importSummary = result;
        await this.getBrokerOrgs();

        const parts = [];
        if (result.created) {
          parts.push(`${result.created} created`);
        }
        if (result.skipped) {
          parts.push(`${result.skipped} skipped`);
        }
        if (result.failed) {
          parts.push(`${result.failed} failed`);
        }
        const summary = parts.join(", ") || "No changes";

        if (result.failed) {
          toasts.error(`CSV import finished with errors (${summary}).`);
          console.warn("Broker org CSV import errors:", result.errors);
        } else {
          toasts.success(`CSV import complete (${summary}).`);
        }
        if (result.errors && result.errors.length) {
          console.table(result.errors);
        }
      } catch (err) {
        console.error(err);
        toasts.error(`CSV import failed: ${err && err.message ? err.message : err}`);
      } finally {
        this.importingCsv = false;
      }
    },
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result || ""));
        reader.onerror = () => reject(reader.error || new Error("Could not read file"));
        reader.readAsText(file);
      });
    },
    normalizeAbn(value) {
      return String(value || "").replace(/\D/g, "");
    },
    normalizeName(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");
    },
    parseCsvLine(line) {
      const cells = [];
      let current = "";
      let inQuotes = false;
      for (let i = 0; i < line.length; i++) {
        const ch = line[i];
        if (ch === '"') {
          if (inQuotes && line[i + 1] === '"') {
            current += '"';
            i++;
          } else {
            inQuotes = !inQuotes;
          }
          continue;
        }
        if (ch === "," && !inQuotes) {
          cells.push(current.trim());
          current = "";
          continue;
        }
        current += ch;
      }
      cells.push(current.trim());
      return cells;
    },
    parseBrokerOrgCsv(text) {
      const lines = String(text || "")
        .replace(/^\uFEFF/, "")
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

      if (lines.length < 2) {
        return [];
      }

      const headers = this.parseCsvLine(lines[0]).map((h) =>
        this.normalizeName(h)
      );
      const indexOf = (aliases) => {
        for (const alias of aliases) {
          const idx = headers.indexOf(this.normalizeName(alias));
          if (idx >= 0) {
            return idx;
          }
        }
        return -1;
      };

      const nameIdx = indexOf(["broker name", "organisation name", "org name", "name"]);
      const abnIdx = indexOf(["abn"]);
      const issuerIdx = indexOf(["insurance issuer", "issuer"]);
      const networkIdx = indexOf(["finance network", "network"]);
      const introducerIdx = indexOf(["introducer"]);
      const notesIdx = indexOf(["notes", "note"]);

      if (nameIdx < 0 || abnIdx < 0 || issuerIdx < 0) {
        throw new Error(
          "CSV must include columns: Broker Name, ABN, Insurance Issuer (Finance Network, Introducer, Notes optional)."
        );
      }

      const rows = [];
      for (let i = 1; i < lines.length; i++) {
        const cells = this.parseCsvLine(lines[i]);
        rows.push({
          lineNumber: i + 1,
          orgName: cells[nameIdx] || "",
          orgABN: cells[abnIdx] || "",
          insuranceIssuer: cells[issuerIdx] || "",
          financeNetwork: networkIdx >= 0 ? cells[networkIdx] || "" : "",
          introducer: introducerIdx >= 0 ? cells[introducerIdx] || "" : "",
          notes: notesIdx >= 0 ? cells[notesIdx] || "" : "",
        });
      }
      return rows;
    },
    findInsuranceIssuer(name) {
      const needle = this.normalizeName(name);
      return this.insuranceBrokerList.find(
        (item) => this.normalizeName(item.insurance_broker_name) === needle
      );
    },
    findFinanceNetwork(name) {
      const needle = this.normalizeName(name);
      return this.financeNetworkList.find(
        (item) => this.normalizeName(item.name) === needle
      );
    },
    findBrokerOrgByName(name, orgs) {
      const needle = this.normalizeName(name);
      return (orgs || []).find(
        (item) => this.normalizeName(item.Broker_Org_Name) === needle
      );
    },
    findBrokerOrgByAbn(abn, orgs) {
      const needle = this.normalizeAbn(abn);
      if (!needle) {
        return null;
      }
      return (orgs || []).find(
        (item) => this.normalizeAbn(item.Broker_org_abn) === needle
      );
    },
    async importBrokerOrgsFromRows(rows) {
      const existingOrgs = [...(this.tableData || [])];
      const result = {
        created: 0,
        skipped: 0,
        failed: 0,
        errors: [],
      };

      for (const row of rows) {
        const orgName = String(row.orgName || "").trim();
        const orgABN = String(row.orgABN || "").trim();
        const insuranceIssuerName = String(row.insuranceIssuer || "").trim();
        const financeNetworkName = String(row.financeNetwork || "").trim();
        const introducerName = String(row.introducer || "").trim();
        const notes = String(row.notes || "").trim();

        if (!orgName && !orgABN) {
          continue;
        }

        if (!orgName || !orgABN || !insuranceIssuerName) {
          result.failed += 1;
          result.errors.push({
            line: row.lineNumber,
            name: orgName || "(blank)",
            reason: "Missing Broker Name, ABN, or Insurance Issuer",
          });
          continue;
        }

        if (this.findBrokerOrgByAbn(orgABN, existingOrgs)) {
          result.skipped += 1;
          result.errors.push({
            line: row.lineNumber,
            name: orgName,
            reason: `Skipped — ABN already exists (${orgABN})`,
          });
          continue;
        }

        const issuer = this.findInsuranceIssuer(insuranceIssuerName);
        if (!issuer) {
          result.failed += 1;
          result.errors.push({
            line: row.lineNumber,
            name: orgName,
            reason: `Unknown Insurance Issuer "${insuranceIssuerName}"`,
          });
          continue;
        }

        let financeNetworkId = null;
        if (financeNetworkName) {
          const network = this.findFinanceNetwork(financeNetworkName);
          if (!network) {
            result.failed += 1;
            result.errors.push({
              line: row.lineNumber,
              name: orgName,
              reason: `Unknown Finance Network "${financeNetworkName}"`,
            });
            continue;
          }
          financeNetworkId = network.finance_network_id;
        }

        let introducerId = "";
        if (introducerName) {
          const introducerOrg = this.findBrokerOrgByName(
            introducerName,
            existingOrgs
          );
          if (!introducerOrg) {
            result.failed += 1;
            result.errors.push({
              line: row.lineNumber,
              name: orgName,
              reason: `Unknown Introducer "${introducerName}"`,
            });
            continue;
          }
          introducerId = introducerOrg.Broker_org_id;
        }

        try {
          const newBrokerOrgIdResp = await appFunctions.crud_brokerOrg(
            "getNextBrokerOrgId"
          );
          const Broker_org_id = newBrokerOrgIdResp.data;
          const payload = {
            Broker_org_id,
            Broker_Org_Name: orgName,
            Broker_org_abn: orgABN,
            insurance_issuer: issuer.insurance_broker_name,
            insurance_issuer_accounts_payable: "",
            insurance_broker_id: issuer.insurance_broker_id,
            is_insurance_broker: false,
            finance_network_id: financeNetworkId,
            notes,
            default_show_lc: true,
            default_show_pe: false,
            default_show_rs: true,
            introducer: introducerId,
            can_see_fleet_management: false,
            can_adjust_policy: false,
            can_see_claims: null,
            can_see_fleet: null,
            can_receive_invoice: null,
            can_cancel_policy: null,
          };

          const createResp = await appFunctions.crud_brokerOrg("create", payload);
          if (createResp.data !== "OK") {
            throw new Error("Create did not return OK");
          }

          existingOrgs.push({
            Broker_org_id,
            Broker_Org_Name: orgName,
            Broker_org_abn: orgABN,
            finance_network_id: financeNetworkId,
          });
          result.created += 1;
        } catch (err) {
          result.failed += 1;
          result.errors.push({
            line: row.lineNumber,
            name: orgName,
            reason: err && err.message ? err.message : String(err),
          });
        }
      }

      return result;
    },
    paginationChanged(page) {
      this.pagination.currentPage = page;
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    formatFinanceNetwork(row) {
      if (!row.finance_network_id) {
        return "—";
      }
      const found = this.financeNetworkList.find(
        item => item.finance_network_id === row.finance_network_id
      );
      return found ? found.name : row.finance_network_id;
    },
    async populateForm(row) {
      var rowResp = await appFunctions.crud_brokerOrg("get", {
        Broker_org_id: row.Broker_org_id
      });

      row = rowResp.data;

      this.activityStatus = "edit";
      this.currentBrokerOrgId = row.Broker_org_id;

      (this.model.orgName = row.Broker_Org_Name),
        (this.model.orgABN = row.Broker_org_abn),
        (this.model.insuranceIssuer = row.insurance_issuer),
        (this.model.insuranceIssuerEmail = row.insurance_issuer_email),
        (this.model.insuranceIssuerAccountsPayable =
          row.insurance_issuer_accounts_payable),
        (this.model.insuranceBrokerId = row.insurance_broker_id);
      this.model.isInsuranceBroker = row.is_insurance_broker;
      this.model.financeNetworkId = row.finance_network_id || null;
      this.model.notes = row.notes || "";
      this.model.defaultShowLc = row.default_show_lc;
      this.model.defaultShowPe = row.default_show_pe;
      this.model.defaultShowRs = row.default_show_rs || false;
      this.model.can_see_fleet_management =
        row.can_see_fleet_management || false;
      this.model.introducer = row.introducer || "";
      this.model.can_cancel_policy =
        row.can_cancel_policy != undefined ? row.can_cancel_policy : null;
      this.model.can_receive_invoice =
        row.can_receive_invoice != undefined ? row.can_receive_invoice : null;
      this.model.can_see_claims =
        row.can_see_claims != undefined ? row.can_see_claims : null;
      this.model.can_see_fleet =
        row.can_see_fleet != undefined ? row.can_see_fleet : null;
      this.model.can_adjust_policy = typeof row.can_adjust_policy === 'undefined' ? row.is_insurance_broker : row.can_adjust_policy
    },
    resetBrokerOrgForm() {
      // Reset flags
      this.activityStatus = "add";
      this.currentBrokerOrgId = "";

      // Reset Modal
      this.model.orgName = "";
      this.model.orgABN = "";
      this.model.insuranceIssuer = "";
      this.model.insuranceIssuerAccountsPayable = "";
      this.model.insuranceBrokerId = "";

      this.model.isInsuranceBroker = false;
      this.model.financeNetworkId = null;
      this.model.notes = "";
      this.model.defaultShowLc = true;
      this.model.defaultShowPe = false;
      this.model.defaultShowRs = true;
      this.model.can_see_fleet_management = false;
      this.model.can_adjust_policy = false;
      this.model.introducer = "";
    },


    /**
     * Initial load and refresh broker orgs. Initializes Fuse.
     */
    async getBrokerOrgs() {
      this.tableData = []
      this.loading = true
      const show = await this.$root.$refs.DashboardLayout.disableOrEnabledMenu()
      await appFunctions.crud_brokerOrg("list").then(res => {
        this.tableData = res.data;
        this.initFuse(["Broker_Org_Name", "insurance_issuer"]);
      }).finally(() => {
        this.loading = false
      });
    },
    // CRUD METHODS
    async saveChanges() {
      const isValid = await this.$refs.formValidator.validate();
      if (!isValid) {
        toasts.error("Please complete the required fields before proceeding.");
        return;
      }

      const insIssuerName = this.insuranceBrokerList.find(
        f => f.insurance_broker_id == this.model.insuranceBrokerId
      ).insurance_broker_name;

      var tmpData = {
        Broker_Org_Name: this.model.orgName,
        Broker_org_abn: this.model.orgABN,
        insurance_issuer: insIssuerName,
        insurance_issuer_accounts_payable: this.model
          .insuranceIssuerAccountsPayable,
        insurance_broker_id: this.model.insuranceBrokerId,
        is_insurance_broker: this.model.isInsuranceBroker,
        finance_network_id: this.model.isInsuranceBroker
          ? null
          : this.model.financeNetworkId || null,
        notes: this.model.notes || "",
        default_show_lc: this.model.defaultShowLc,
        default_show_pe: this.model.defaultShowPe,
        default_show_rs: this.model.defaultShowRs,
        introducer: this.model.introducer,
        can_see_fleet_management: this.model.can_see_fleet_management,
        can_see_claims: this.model.can_see_claims,
        can_see_fleet: this.model.can_see_fleet,
        can_receive_invoice: this.model.can_receive_invoice,
        can_cancel_policy: this.model.can_cancel_policy,
        can_adjust_policy: this.model.can_adjust_policy
      };

      if (this.currentBrokerOrgId) {
        // Existing broker has been edited
        tmpData.Broker_org_id = this.currentBrokerOrgId;

        appFunctions
          .crud_brokerOrg("update", tmpData)
          .then(res => {
            if (res.data == "OK") {
              this.getBrokerOrgs();
              this.resetBrokerOrgForm();
              toasts.success("Broker Org updated successfully!");
            }
          })
          .catch(err => {
            console.error(err);
            toasts.error(`Failed to update organisation: ${err}`);
          });
      } else {
        // New broker will be added
        var newBrokerOrgId = await appFunctions.crud_brokerOrg(
          "getNextBrokerOrgId"
        );
        tmpData.Broker_org_id = newBrokerOrgId.data;

        appFunctions
          .crud_brokerOrg("create", tmpData)
          .then(res => {
            if (res.data == "OK") {
              this.getBrokerOrgs();
              this.resetBrokerOrgForm();
              toasts.success("Broker Org created successfully!");
            }
          })
          .catch(err => {
            toasts.error(`Failed to add organisation: ${err}`);
          });
      }
    }
  },
  computed: {
    /**
     * Returns list of broker orgs. If editing an org, will return all orgs except current.
     */
    getBrokerOrgList() {
      return this.tableData.filter(
        org => org.Broker_org_id !== this.currentBrokerOrgId
      );
    }
  },

  async mounted() {
    this.loading = true;
    this.realmApp = GlobalStore.realmApp;
    await this.getBrokerOrgs();

    appFunctions.crud_insuranceBroker("list").then(resp => {
      this.insuranceBrokerList = resp.data;
    });
    appFunctions.crud_financeNetwork("list", {}).then(resp => {
      this.financeNetworkList = resp.data || [];
    });
  },
  mixins: [clientPaginationMixin],
  components: {
    BaseInput,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ButtonRadioGroup
  }
};
</script>

<style lang="scss"></style>
